<template>
  <div class="page-container">
    <div class="page-title">{{ $t('operation.franchisee_detail') }}</div>
    <el-descriptions v-loading="loading" :column="1" border class="detail-content">
      <el-descriptions-item :label="$t('operation.franchisee_no')">{{ detail.franchisee_no || '-' }}</el-descriptions-item>
      <el-descriptions-item :label="$t('operation.franchisee_name')">{{ detail.franchisee_name || '-' }}</el-descriptions-item>
      <el-descriptions-item :label="$t('operation.region')">{{ detail.country_code || '-' }}</el-descriptions-item>
      <el-descriptions-item :label="$t('operation.currency')">{{ detail.currency || '-' }}</el-descriptions-item>
      <el-descriptions-item :label="$t('operation.contact_name')">{{ detail.contact_name || '-' }}</el-descriptions-item>
      <el-descriptions-item :label="$t('operation.contact_phone')">{{ detail.contact_phone || '-' }}</el-descriptions-item>
      <el-descriptions-item :label="$t('operation.contact_email')">{{ detail.contact_email || '-' }}</el-descriptions-item>
      <el-descriptions-item :label="$t('operation.remark')">{{ detail.remark || '-' }}</el-descriptions-item>
      <el-descriptions-item :label="$t('operation.description')">{{ detail.description || '-' }}</el-descriptions-item>
      <el-descriptions-item :label="$t('operation.create_time')">{{ detail.create_time || '-' }}</el-descriptions-item>
      <el-descriptions-item :label="$t('merchantAccount.update_time')">{{ detail.update_time || '-' }}</el-descriptions-item>
    </el-descriptions>
    <div class="page-footer">
      <el-button type="primary" @click="$router.back()">{{ $t('components.confirm') }}</el-button>
    </div>
  </div>
</template>

<script>
import { fetchFranchiseeDetail } from '@/api/operation-manage/franchisee'

export default {
  name: 'FranchiseeDetail',
  data() {
    return {
      loading: false,
      detail: {}
    }
  },
  created() {
    this.getFranchiseeDetail()
  },
  methods: {
    getFranchiseeDetail() {
      const { franchisee_no } = this.$route.query
      if (!franchisee_no) return
      this.loading = true
      fetchFranchiseeDetail(franchisee_no).then(response => {
        if (response.code === 10000) this.detail = response.data
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  margin: 40px 57px 50px 32px;
}
.page-title {
  padding-bottom: 24px;
  border-bottom: 1px solid #D3D7DF;
}
.detail-content {
  margin-top: 32px;
}
.page-footer {
  margin-top: 24px;
  text-align: center;
}
</style>
